import { createMachine } from 'xstate'
import { extractAllStates } from '@/composition/useXState'

import type { Typegen0 } from './PmMultipleResourceAllocationsControllerState.typegen'

export type State = Typegen0['matchesStates']

export const PmMultipleResourceAllocationsControllerPureState = createMachine({
  tsTypes:
    {} as import('./PmMultipleResourceAllocationsControllerPureState.typegen').Typegen0,
  schema: {},

  id: 'PmMultipleResourceAllocationsControllerPureState',
  initial: 'default',

  states: {
    default: {},
  },
})

export const states = extractAllStates(
  PmMultipleResourceAllocationsControllerPureState
)
